export const OTP_FOR = {
    REGISTER: 1,
    LOGIN: 2,
    FORGOT_PASSWORD: 3,
    VERIFICATION: 4,
} as const;

export const Group_Type = {
    INTERIOR: 1,
    EXTERIOR: 2,
    EQUIPMENT:3,
} as const;

export const Field_Type = {
    RADIO: 1,
    CHECKBOX: 2,
    SELECT: 3,
    BOOLEAN: 4,
    INPUT: 5
} as const;

export enum VEHICLE_TYPE {
    CAR = 1,
    BIKE = 2,
    BICYCLE = 3,
    CARAVAN = 4,
    TRUCK = 5,
    HEAVY_VEHICLE = 6
}

export enum SELLER_TYPE {
    PERSONAL = 1,
    BUSINESS = 2
}

export const GENDER = {
    MALE: 1,
    FEMALE: 2,
    OTHER: 3,
} as const;

    export enum PAYMENT_MODE {
        CASH = 1, // Purchase
        ONLINE = 2, // Leasing
}

export enum VEHICLE_CONDITION {
    BRAND_NEW = 1,          // 0 km, never registered
    LIKE_NEW = 2,           // very low usage
    EXCELLENT = 3,          // minimal wear
    GOOD = 4,               // normal daily usage
    FAIR = 5,               // noticeable wear & tear
    POOR = 6,               // mechanical or cosmetic issues
    DAMAGED = 7,            // accident or broken
    NON_RUNNING = 8,        // engine not working
    FOR_PARTS = 9,          // scrap / dismantle
    RESTORED = 10,          // rebuilt / refurbished
    CLASSIC = 11            // vintage collectible condition
}

export enum RENTAL_DURATION {
    DAILY = 1,
    WEEKLY = 2,
    MONTHLY = 3,
    YEARLY = 4
}

export enum RESOURCES {
    DASHBOARD = 1,
    CUSTOMER_MANAGEMENT = 2,
    CATEGORIES_MANAGEMENT = 3,
    LISTINGS_MANAGEMENT = 4,
    VEHICLE_SPECIFICATION = 5,
    MANAGE_PACKAGES = 6,
    REVENUE_MANAGEMENT = 7,
    REPORT_ANALYTICS = 8,
    NOTIFICATION_MANAGEMENT = 9,
    SUB_ADMIN_MANAGEMENT = 10,
    BLOG_MANAGEMENT = 11,
    CMS_MANAGEMENT = 12,
}

export enum RECIPIENT_TYPE {
    ALL = "1",
    CUSTOMERS = "2",
    DEALERS = "3",
}

export enum NOTIFICATION_TYPE {
    BROADCAST = "BROADCAST",
    EMAIL = "EMAIL",
    PUSH = "PUSH",
}

export enum PLATFORM_TYPE {
    WEB = 1,
    APP = 2,
}